import React from "react";
import OrgInvitations from "../../org/invitation/index";

const AdminInvitation = () => {
  return <OrgInvitations isAdminMode={true} />;
};

export default AdminInvitation;
